export class FiltrosUsuarioModel {
  nome: string = '';
  setorId?: number;
  perfilId?: number;
  ativo?: boolean = true;
}
